import React, { useState, useEffect, useContext } from "react";
import classNames from "classnames/bind";
import styles from "./CustomerCare.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import { ToastContext } from "~/components/context/ToastContext";
import { BASE_CUSTOMER_CARE_URL } from "~/helper/apiService";

const cx = classNames.bind(styles);

function StatisticsPage() {
  const [loading, setLoading] = useState(false);
  const [statistics, setStatistics] = useState(null);
  const { showToast } = useContext(ToastContext);

  useEffect(() => {
    fetchStatistics();
  }, []);

  const fetchStatistics = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BASE_CUSTOMER_CARE_URL}/statistics`, {
        credentials: "include",
      });
      const data = await response.json();
      if (data.success) {
        setStatistics(data.statistics);
      } else {
        showToast(data.error || "Lỗi khi lấy thống kê", "error");
      }
    } catch (error) {
      showToast("Lỗi kết nối: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateStatistics = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BASE_CUSTOMER_CARE_URL}/update-statistics`, {
        method: "POST",
        credentials: "include",
      });
      const data = await response.json();
      if (data.success) {
        showToast("Đã cập nhật sheet Thống kê thành công", "success");
        await fetchStatistics();
      } else {
        showToast(data.error || "Lỗi khi cập nhật thống kê", "error");
      }
    } catch (error) {
      showToast("Lỗi kết nối: " + error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const parseValue = (value) => {
    if (value === null || value === undefined || value === "") return 0;
    if (typeof value === "number") return value;
    if (typeof value === "string") {
      // Loại bỏ các ký tự không phải số
      const cleaned = value.replace(/[^\d]/g, "");
      const num = parseInt(cleaned, 10);
      return isNaN(num) ? 0 : num;
    }
    return 0;
  };

  return (
    <div className={cx("customer-care")}>
      <div className={cx("header")}>
        <h2 className={cx("title")}>Thống Kê Chăm Sóc Khách Hàng</h2>
        <div className={cx("actions")}>
          <button
            className={cx("button", "update-button")}
            onClick={handleUpdateStatistics}
            disabled={loading}
          >
            <FontAwesomeIcon icon={faSync} spin={loading} /> Update
          </button>
        </div>
      </div>

      <div className={cx("tab-content")}>
        {statistics ? (
          <div className={cx("statistics-overview")}>
            <div className={cx("stat-item", "total")}>
              <span className={cx("stat-label")}>Tổng số khách hàng</span>
              <span className={cx("stat-value")}>{parseValue(statistics.overview.total)} khách</span>
            </div>
            <div className={cx("stat-item", "urgent")}>
              <span className={cx("stat-label")}>🔥 Khách cần chăm sóc ngay (0-30 ngày, chưa CSKH)</span>
              <span className={cx("stat-value")}>{parseValue(statistics.overview.urgent)} khách</span>
            </div>
            <div className={cx("stat-item", "risk")}>
              <span className={cx("stat-label")}>⚠️ Nguy cơ rơi (30–59 ngày)</span>
              <span className={cx("stat-value")}>{parseValue(statistics.overview.risk)} khách</span>
            </div>
            <div className={cx("stat-item", "cold")}>
              <span className={cx("stat-label")}>❄️ Lạnh (60–89 ngày)</span>
              <span className={cx("stat-value")}>{parseValue(statistics.overview.cold)} khách</span>
            </div>
            <div className={cx("stat-item", "lost")}>
              <span className={cx("stat-label")}>Mất khách (≥90 ngày)</span>
              <span className={cx("stat-value")}>{parseValue(statistics.overview.lost)} khách</span>
            </div>
            <div className={cx("stat-item")}>
              <span className={cx("stat-label")}>Tổng khách tiềm năng (đi ≥2 lần)</span>
              <span className={cx("stat-value")}>{parseValue(statistics.overview.potential)} khách</span>
            </div>
            <div className={cx("stat-item")} style={{ background: "#e3f2fd" }}>
              <span className={cx("stat-label")}>📞 Tổng số khách đã chăm sóc</span>
              <span className={cx("stat-value")}>{parseValue(statistics.overview.totalCared)} khách</span>
            </div>
            <div className={cx("stat-item")}>
              <span className={cx("stat-label")}>Đã chăm sóc thành công</span>
              <span className={cx("stat-value")}>{parseValue(statistics.overview.cared)} khách</span>
            </div>
            <div className={cx("stat-item", "last-update")}>
              <span className={cx("stat-label")}>Cập nhật lần cuối:</span>
              <span className={cx("stat-value")}>{statistics.overview.lastUpdate || "Chưa cập nhật"}</span>
            </div>
          </div>
        ) : (
          <div className={cx("no-data")}>Chưa có dữ liệu thống kê. Vui lòng nhấn Update để cập nhật.</div>
        )}
      </div>
    </div>
  );
}

export default StatisticsPage;
